import React, { useState, useEffect, useContext } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid, Snackbar, Alert, MenuItem, FormControl, InputLabel, Select
  , useTheme, useMediaQuery
} from "@mui/material";
import { ThemeContext } from "../../../../../../../../context/ThemeContextProvider";
import {  fetchCaptains } from "../../../../../../../../services/pos/Tables";
import { useOrder } from "../../../../../../../../context/OrderCreator/TablesContext/OrderContext";

const EditOrderForm = ({ open, onClose, initialData }) => {
  const { mode } = useContext(ThemeContext);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // phone
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1200px)"); // tablet/iPad
  const controlSize = isTablet ? "medium" : isXs ? "small" : "small";
  const dialogWidth = isXs ? "100vw" : isTablet ? "90vw" : 560;
  const [form, setForm] = useState({});
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [captains, setCaptains] = useState([]);
  const { updateOrderData } = useOrder();


  useEffect(() => {
    if (initialData) setForm(initialData);
  }, [initialData]);

  useEffect(() => {
    if (open) {
      fetchCaptains()
        .then((data) => setCaptains(data))
        .catch((err) => setCaptains([]));
    }
  }, [open]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (!form.order_id) throw new Error("❌ رقم الأوردر غير موجود");

      await updateOrderData(form.order_id, {
        captain_order_id: form.captain_order_id,
        table_id: form.table_id || "",
        customer_id: form.customer_id || form.customer?.id || "",
      });

      setSuccess(true);
      onClose(true);
    } catch (err) {
      setError(err.message || "❌ فشل في التعديل");
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullScreen={isXs}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: dialogWidth,
            maxWidth: "98vw",
            bgcolor: mode === "dark" ? "#232334" : "#fff",
            color: mode === "dark" ? "#fff" : "#232334",
            borderRadius: { xs: 0, sm: 3 },
          },
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 700,
              fontSize: { xs: 18, sm: 20, md: 22 },
              textAlign: "center",
              color: "#EA7C69",
              bgcolor: mode === "dark" ? "#181824" : "#fff",
              borderRadius: "16px 16px 0 0",
            }}
          >
            تعديل بيانات الكابتن
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              bgcolor: mode === "dark" ? "#232334" : "#fff",
              pb: 2,
            }}
          >
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12}>
                <FormControl fullWidth sx={{ bgcolor: mode === "dark" ? "#181824" : "#fff", borderRadius: 2 }}>
                  <InputLabel sx={{ color: mode === "dark" ? "#aaa" : undefined }}>اختر الكابتن</InputLabel>
                  <Select
                    label="اختر الكابتن"
                    name="captain_order_id"
                    value={form.captain_order_id || ""}
                    onChange={handleChange}
                    size={controlSize}
                    sx={{
                      color: mode === "dark" ? "#fff" : "#232334",
                      ".MuiOutlinedInput-notchedOutline": {
                        borderColor: mode === "dark" ? "#444" : "#ccc",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          bgcolor: mode === "dark" ? "#232334" : "#fff",
                          color: mode === "dark" ? "#fff" : "#232334",
                        },
                      },
                    }}
                  >
                    {captains.map((captain) => (
                      <MenuItem key={captain.id} value={captain.id}>
                        {captain.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ bgcolor: mode === "dark" ? "#232334" : "#fff", borderRadius: "0 0 16px 16px", px: { xs: 2, sm: 3 }, py: { xs: 1, sm: 1.25 } }}>
            <Button
              onClick={() => onClose(false)}
              variant="outlined"
              color="secondary"
              size={controlSize}
              sx={{
                minWidth: 100,
                borderColor: mode === "dark" ? "#888" : undefined,
                color: mode === "dark" ? "#fff" : undefined,
                px: { xs: 2, sm: 3 },
                py: { xs: 0.7, sm: 0.6 },
              }}
            >
              إلغاء
            </Button>
            <Button
              variant="contained"
              type="submit"
              size={controlSize}
              sx={{
                bgcolor: "#EA7C69",
                color: "#fff",
                minWidth: 120,
                fontWeight: 700,
                "&:hover": { bgcolor: "#d45d4c" },
                px: { xs: 3, sm: 4 },
                py: { xs: 0.8, sm: 0.7 },
                ml: 1,
              }}
            >
              حفظ التعديلات
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Snackbar open={!!error} autoHideDuration={3000} onClose={() => setError("")}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
      <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
        <Alert severity="success">✅ تم التعديل بنجاح</Alert>
      </Snackbar>
    </>
  );
};

export default EditOrderForm;
